import {
    Component,
    ComponentRef,
    EventEmitter,
    Input,
    Output,
    SimpleChanges,
    Type,
    ViewChild,
    ViewContainerRef
} from "@angular/core";
import {FilterSettings} from '../filter'
import {FilterComponent} from "../filter/filter.component";
import {Subscription} from "rxjs";

@Component({
    selector: 'filter-wrapper',
    template: `<ng-template #filterHost></ng-template>`,
    styles: [':host { display: inline-flex; width: 50% !important; }']
})
export class FilterWrapperComponent {
    @ViewChild('filterHost', {read: ViewContainerRef})
    public FilterHost: ViewContainerRef;
    
    @Input('filterType')
    public FilterType: Type<FilterComponent>;
    
    @Input('filterInputs')
    public FilterInputs: any;

    @Input('filterSettings')
    public FilterSettings: FilterSettings;

    @Input('autofocus')
    public Autofocus: boolean;
    
    @Output('filterSettingsChange')
    public FilterSettingsChange = new EventEmitter<FilterSettings>();

    @Output('filterInputComplete')
    public FilterInputComplete = new EventEmitter<any>();
    
    private _component: ComponentRef<FilterComponent>;
    private _oldFilterType: Type<FilterComponent>;
    private _filterSubscription: Subscription;
    
    private _isViewInitialized: boolean = false;

    constructor(public viewContainerRef: ViewContainerRef) {
        this.FilterHost = viewContainerRef;
    }

    updateComponent() {
        if(!this._isViewInitialized) {
            return;
        }
        
        if(this._component) {
            if (this._filterSubscription) {
                this._filterSubscription.unsubscribe();
            }
            this._component.destroy();
        }
        
        this._component = this.FilterHost.createComponent(this.FilterType);
        (<HTMLElement>this._component.location.nativeElement).className = 'row col-12 d-inline-flex';
        this._oldFilterType = this.FilterType;
        
        this._component.instance.FilterInputs = this.FilterInputs;
        this._component.instance.FilterSettings = this.FilterSettings;
        this._component.instance.Autofocus = this.Autofocus;
        this._filterSubscription = this._component.instance.FilterSettingsChange.subscribe(filter => {
            this.FilterSettings = filter;
            this.FilterSettingsChange.emit(filter);
        });
        this._filterSubscription = this._component.instance.FilterInputComplete.subscribe(filter => {
            this.FilterInputComplete.emit();
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['FilterType']) {
            this.updateComponent();
        }
        else {
            if (changes['FilterInputs']) {
                this._component.instance.FilterInputs = this.FilterInputs;
            }
            if (changes['FilterSettings']) {
                this._component.instance.FilterSettings = this.FilterSettings;
            }
        }
    }

    ngAfterViewInit() {
        this._isViewInitialized = true;
        setTimeout(() => this.updateComponent(), 50);
    }

    ngOnDestroy() {
        if(this._component) {
            this._component.destroy();
        }
    }
}